import { createContext, useMemo, useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { lightTheme, darkTheme } from "./Theme";

export const ColorModeContext = createContext({
  mode: "light",
  toggleColorMode: () => {},
  setColorMode: () => {}
});

export default function CustomThemeProvider({ children }) {
  const storedMode = localStorage.getItem("mui-theme-mode") || "light";
  const [mode, setMode] = useState(storedMode);

  useEffect(() => {
    localStorage.setItem("mui-theme-mode", mode);
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () => {
        setMode((prev) => (prev === "light" ? "dark" : "light"));
      },
      setColorMode: (newMode) => {
        setMode(newMode);
      },
    }),
    [mode]
  );

  const theme = useMemo(
    () => (mode === "light" ? lightTheme : darkTheme),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
